import BankAccountEditForm from '@/components/bankAccounts/editForm/BankAccountEditForm';
import { SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetBankAccountDetails } from '@/hooks/requests/useBankAccounts';
import { useGetTeammateListForSelection } from '@/hooks/requests/useTeammates';
import { TeammateRole } from '@/types/teammates';
import { generateBankAccountDisplayName } from '@/utils/bankAccounts';
import { Card, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function BankAccountsEditPage() {
  const { uuid = '' } = useParams();
  const { accountDetails, accountsDetailsIsPending } =
    useGetBankAccountDetails(uuid);

  const companyId = accountDetails ? accountDetails.company?.uuid : '';
  const { teammatesList, isTeammatesListPending } =
    useGetTeammateListForSelection(
      {
        company_id: companyId,
        roles: [TeammateRole.ADMIN, TeammateRole.ADVISOR],
      },
      !!companyId,
    );

  if (accountsDetailsIsPending || isTeammatesListPending) {
    return (
      <DefaultLayout header="Bank Account Edit">
        <SVLoader />
      </DefaultLayout>
    );
  }

  if (!accountDetails) {
    return (
      <DefaultLayout header="Bank Account Edit">
        <Card>
          <Typography>
            Something went wrong retreiving the bank account. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  const { applicationType, business, primaryOwner, owners } = accountDetails;
  const { fullName, email } = primaryOwner.profile;
  const { name: businessName } = business || {};
  const totalOwners = owners.length;

  const header = generateBankAccountDisplayName({
    applicationType,
    businessName,
    fullName,
    email,
    totalOwners,
  });

  return (
    <DefaultLayout
      header={header}
      breadcrumb={[
        { label: 'Bank Accounts', href: ROUTES.BANK_ACCOUNTS },
        { label: header, href: `${ROUTES.BANK_ACCOUNTS}/${uuid}` },
        { label: 'Edit', isActive: true },
      ]}>
      <BankAccountEditForm
        accountDetails={accountDetails}
        teammatesList={teammatesList}
      />
    </DefaultLayout>
  );
}
